const CustomLightboxTypes = {
    VIMEO: 'vimeo'
}

class CustomLightbox {
    constructor() {
        this.lightboxes = [];
        this.lightbox = null;

        this.init();
    }

    init() {
        this.getAllDOMLightboxes();
        this.onClickListener();+

        console.log('Initialised');
    }

    getLightboxContent(lightbox) {
        const type = lightbox.getAttribute('data-lightbox-type');

        let content = null

        if (type == CustomLightboxTypes.VIMEO) {
            const src = lightbox.getAttribute('data-lightbox-src');

            if (src === false) return this.error('No src set for lightbox video');

            content = `
                <iframe
                    id="vimeo"
                    src="${src}"
                    width="1920" height="1080" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
                    title="Your home from home, at DMC"></iframe>
            `;
        }

        return content;
    }

    makeCloseButton(lightbox) {
        const close = document.createElement('span');

        close.className = "custom-lightbox__close";
        close.innerText = 'X';

        lightbox.appendChild(close);

        close.onclick = () => this.destroyLightbox();

        return close;
    }

    getAllDOMLightboxes() {
        const lightboxes = document.querySelectorAll('[data-lightbox]');

        console.log(lightboxes)

        if (lightboxes.length == 0) return;

        let mappedLightboxes = Array.from(lightboxes).map(lightbox => ({
            domNode: lightbox,
            content: this.getLightboxContent(lightbox)
        }));

        this.lightboxes = mappedLightboxes;
    }

    onClickListener() {
        this.lightboxes.forEach(lightbox => {
            lightbox.domNode.addEventListener('click', () => this.onClickEvent(lightbox));
        })
    }

    onClickEvent(lightbox) {
        console.log('Clicked lightbox', lightbox);
        
        this.openLightbox(lightbox.content);
    }

    openLightbox(content) {
        this.lightbox = document.createElement('div');
        this.lightbox.className = 'custom-lightbox';

        if (content == null) return this.error('HTML content is empty');

        this.lightbox.innerHTML = content;

        document.body.appendChild(this.lightbox);

        this.makeCloseButton(this.lightbox);
    }

    destroyLightbox() {
        this.lightbox.remove();
    }

    error(msg) {
        throw new Error('[CustomLightbox] ' + msg);
    }
}

new CustomLightbox();